export default {
  pt: {
    attention: "Atenção: A aceitação do risco de seguros é critério exclusivo da seguradora.",
  },
  en: {
    attention: "Attention: The acceptance of insurance risk is the exclusive criterion of the insurer.",
  },
}; 